import React, { useEffect, useState } from "react";
import Reviewtable from "./Reviewtable";
import Newplaylist from "../playlist/Newplaylist";
import { Form, InputGroup } from "react-bootstrap";
import PlaylistReview from "./PlaylistReview";
import ReviewplaylistTable from "./ReviewplaylistTable";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { toast } from "react-toastify";

const ReviewList = ({ fetchNotReviewedVideosCOunr }) => {
  const [active, setActive] = useState("tab-1");
  const [products, setProducts] = useState([]);
  const [showsearch, setShowSearch] = useState("");
  const [playlist, setPlaylist] = useState([]);
  const navigate = useNavigate();
  const location = useLocation();
  const [search, setSearch] = useState("");
  const searchParams = new URLSearchParams(location.search);
  const Playlist = searchParams.get("CreateModeratorPlaylist") === "true";
  const setCreateModeratorPlaylist = (value) => {
    searchParams.set("CreateModeratorPlaylist", value);
    navigate({ search: searchParams.toString() });
  };
  const submitModeratorPlaylist = (value) => {
    searchParams.set("ModeratorPlaylistSubmit", value);
    navigate({ search: searchParams.toString() });
  };
  const shouldShowSearchBar = () => {
    if (Playlist == true || active === "tab-1") {
      return true;
    }
  };

  const getPlaylist = async () => {
    try {
      const response = await axios.get(
        `  ${process.env.REACT_APP_API_URL_PDP}/api/playlists`,

        {
          headers: {
            Authorization: localStorage.getItem("token")
              ? localStorage.getItem("token")
              : "",
          },
        }
      );
      setPlaylist(response.data.data.filter((item) => !item.isDeleted));
    } catch (error) {
      console.error("Error:", error);
      toast.error("Failed to fetch playlist");
    }
  };
  const [debouncedSearch, setDebouncedSearch] = useState(showsearch);
  const [debouncedSearchQuery, setDebouncedSearchQuery] = useState(search);
  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedSearch(showsearch);
      setDebouncedSearchQuery(search);
    }, 300); // Adjust delay as needed

    return () => {
      clearTimeout(handler);
    };
  }, [showsearch, search]);

  const filteredProducts = products.filter((item) =>
    item.product.name.toLowerCase().includes(debouncedSearch.toLowerCase())
  );

  useEffect(() => {
    getPlaylist();
  }, []);

  useEffect(() => {
    shouldShowSearchBar();
  }, [Playlist, active]);

  return (
    <div className="h-100">
      <div className="d-flex ">
        <ul
          className=" nav nav-pills nav-justified ReviewlistnavTab"
          id=" responsive-tabs-review-list"
          role="tablist"
        >
          <li className="nav-item " role="presentation">
            <button
              className={`nav-link ${active === "tab-1" ? "active" : ""}`}
              id="moderator-tab"
              data-bs-toggle="tab"
              data-bs-target="#moderator"
              type="button"
              role="tab"
              aria-controls="moderator"
              aria-selected={active === "tab-1"}
              onClick={() => {
                setActive("tab-1");
                setCreateModeratorPlaylist(false);
                submitModeratorPlaylist(false);
                setShowSearch("");
              }}
            >
              Product
            </button>
          </li>

          <li className="nav-item" role="presentation">
            <button
              className={`nav-link ${active === "tab-2" ? "active" : ""}`}
              id="moderator-tab"
              data-bs-toggle="tab"
              data-bs-target="#moderator"
              type="button"
              role="tab"
              aria-controls="moderator"
              aria-selected={active === "tab-2"}
              onClick={() => {
                setActive("tab-2");
                setCreateModeratorPlaylist(false);
                submitModeratorPlaylist(false);
                setShowSearch("");
              }}
            >
              Playlist
            </button>
          </li>
        </ul>
        {active === "tab-1" && (
          <div className="position-absolute" style={{ right: "20px" }}>
            <InputGroup
              className=" no-space-group"
              style={{
                border: "1px solid rgba(209, 209, 210, 1)",
                borderRadius: "7px",
              }}
            >
              <InputGroup.Text
                id="basic-addon1"
                style={{
                  backgroundColor: "white",
                  border: "none",
                  padding: "6px",
                }}
              >
                <i className="ri-search-line"></i>
              </InputGroup.Text>
              <Form.Control
                className="form-control"
                type="search"
                placeholder="search product"
                onChange={async (e) => {
                  {
                    setShowSearch(e.target.value);
                    // console.log(e.target.value);
                  }
                }}
              />
            </InputGroup>
          </div>
        )}
        {Playlist && playlist.length == 0 && (
          <div className="position-absolute" style={{ right: "20px" }}>
            <InputGroup
              className=" no-space-group"
              style={{
                border: "1px solid rgba(209, 209, 210, 1)",
                borderRadius: "7px",
              }}
            >
              <InputGroup.Text
                id="basic-addon1"
                style={{
                  backgroundColor: "white",
                  border: "none",
                  padding: "6px",
                }}
              >
                <i className="ri-search-line"></i>
              </InputGroup.Text>
              <Form.Control
                className="form-control"
                type="search"
                placeholder="search product"
                onChange={async (e) => {
                  {
                    setSearch(e.target.value);
                    // console.log(e.target.value);
                  }
                }}
              />
            </InputGroup>
          </div>
        )}
      </div>
      {active === "tab-1" && (
        <div
          className="tab-pane fade show active"
          id="settings"
          role="tabpanel"
          aria-labelledby="settings-tab"
          style={{ height: "calc(100% - 30px)" }}
        >
          <Reviewtable
            fetchNotReviewedVideosCOunr={fetchNotReviewedVideosCOunr}
            products={products}
            setProducts={setProducts}
            filteredProducts={filteredProducts}
          />
        </div>
      )}
      {active === "tab-2" && (
        <div
          className="tab-pane fade show active"
          id="settings"
          role="tabpanel"
          aria-labelledby="settings-tab"
          style={{ height: "calc(100% - 30px)" }}
        >
          {playlist.length == 0 ? (
            <Newplaylist
              moderator={true}
              getPlaylist={getPlaylist}
              showsearch={debouncedSearchQuery}
            />
          ) : (
            <ReviewplaylistTable
              playlist={playlist}
              getPlaylist={getPlaylist}
            />
          )}

          {/* */}
          {/* <ReviewplaylistTable /> */}
        </div>
      )}
    </div>
  );
};

export default ReviewList;
